import { createStore } from "./_createStore";

type GlobalAppVersionState = {
  minimumAppVersionSupported: string;
  showFlashMessage: boolean;
  setGlobalAppVersion: (
    state: Partial<Omit<GlobalAppVersionState, "setGlobalAppVersion">>,
  ) => void;
};

export const useGlobalAppVersionStore = createStore<GlobalAppVersionState>(
  (set) => ({
    minimumAppVersionSupported: "",
    showFlashMessage: false,
    setGlobalAppVersion: (state) => set(state),
  }),
  "GlobalAppVersionStore",
);
